import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import getColors from 'utils/getColors';
import { DotProps } from 'types/components';

const Dot = ({ color, size, variant, sx }: DotProps) => {
    const theme = useTheme();
    const colors = getColors(theme, color || 'primary');
    const { main } = colors;

    return (
        <Box
            component='span'
            sx={{
                width: size || 8,
                height: size || 8,
                borderRadius: '50%',
                bgcolor: variant === 'outlined' ? '' : main,
                ...(variant === 'outlined' && {
                    border: `1px solid ${main}`,
                }),
                ...sx,
            }}
        />
    );
};

export default Dot;
